import { MissingRequiredParameterError } from './errors';
import { commonIntegrationDataToQuery, integrationDataFromQuery } from './integration-data';
export function planCustomizationDataFromQuery(query) {
  const planId = query.get('planId') ?? undefined;
  const planSlug = query.get('planSlug') ?? undefined;
  const {
    navigateTo,
    navigateToPageProps,
    navigateToSectionProps,
    maxStartDate,
    minStartDate,
    biOptions,
    verticalStatusContent
  } = integrationDataFromQuery(query);
  const integrationData = {
    navigateTo,
    navigateToPageProps,
    navigateToSectionProps,
    minStartDate,
    maxStartDate,
    biOptions,
    verticalStatusContent
  };
  if (planId) {
    return {
      ...integrationData,
      planId,
      planSlug: undefined
    };
  } else if (planSlug) {
    return {
      ...integrationData,
      planSlug,
      planId: undefined
    };
  } else {
    throw new MissingRequiredParameterError('planId', 'planSlug');
  }
}
export function planCustomizationDataToQuery(data) {
  const query = commonIntegrationDataToQuery(data.integrationData);
  query.set('planId', data.planId);
  return query;
}
//# sourceMappingURL=plan-customization-data.js.map